// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* In-chat product gallery — horizontally scrollable cards the agent attaches
   to a reply. Modern, brand-aligned (#5e1bff), soft depth, hover lift. */

.ub-pc {
  position: relative;
  width: 100%;
}

.ub-pc-track {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  /* vertical room so hover-lift + shadow are never clipped */
  padding: 6px 2px 10px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;          /* Firefox */
}
.ub-pc-track::-webkit-scrollbar { display: none; }  /* WebKit */

/* ── Card ─────────────────────────────────────────────────────────────── */
.ub-pc-card {
  flex: 0 0 auto;
  width: 190px;
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #ececf1;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 1px 2px rgba(20, 20, 40, 0.04);
  /* Pre-promote to its own GPU layer so the lift composites frame-1-smooth —
     without this the browser promotes the layer mid-hover, which is the jank. */
  will-change: transform;
  backface-visibility: hidden;
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
              box-shadow 0.3s ease,
              border-color 0.3s ease;
}
.ub-pc-card-link { cursor: pointer; }
.ub-pc-card-link:hover {
  /* Keep the subtle lift, but no glow shadow (was brand-purple, which clashes
     with customers' custom widget colours) and a neutral darker-grey border. */
  transform: translateY(-4px);
  border-color: #cfcfd6;
}

/* ── Image ────────────────────────────────────────────────────────────── */
.ub-pc-img {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;          /* fixed -> no layout shift while images load */
  background: linear-gradient(135deg, #f5f3ff 0%, #f0f0f5 100%);
  overflow: hidden;
}
.ub-pc-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  /* Sit on a GPU layer for the whole zoom: buttery scaling with no sub-pixel
     edge shimmer. translateZ(0) is carried into the hover transform so it never
     leaves the layer. */
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
  transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
}
.ub-pc-card-link:hover .ub-pc-img img { transform: scale(1.06) translateZ(0); }

.ub-pc-img-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b9b4d6;
  font-size: 30px;
}

.ub-pc-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 3px 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #2c2c3a;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(6px);
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(20, 20, 40, 0.12);
  text-transform: capitalize;
}

/* ── Body ─────────────────────────────────────────────────────────────── */
.ub-pc-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 11px 12px 12px;
  flex: 1 1;
}

.ub-pc-brand {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8a86a0;
}

.ub-pc-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a2e;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ub-pc-specs {
  font-size: 11.5px;
  line-height: 1.35;
  color: #6f6b82;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
}

.ub-pc-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  padding-top: 9px;
}

.ub-pc-price {
  font-size: 15px;
  font-weight: 700;
  color: #15151f;
  white-space: nowrap;
}

.ub-pc-cta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  color: #5e1bff;
  white-space: nowrap;
}
.ub-pc-cta-ic { font-size: 9px; }
.ub-pc-card-link:hover .ub-pc-cta { text-decoration: underline; }

/* ── Scroll arrows ────────────────────────────────────────────────────── */
.ub-pc-arrow {
  position: absolute;
  top: calc(50% - 12px);          /* roughly centred on the image, not the text */
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid #ececf1;
  background: #ffffff;
  color: #3a3550;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
  box-shadow: 0 4px 14px rgba(20, 20, 40, 0.16);
  transition: opacity 0.2s ease, transform 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.ub-pc-arrow:hover { background: #5e1bff; color: #fff; border-color: #5e1bff; }
.ub-pc-arrow:active { transform: translateY(-50%) scale(0.92); }
.ub-pc-arrow-l { left: -6px; }
.ub-pc-arrow-r { right: -6px; }

.ub-pc-arrow-off {
  opacity: 0;
  pointer-events: none;
}

@media (max-width: 768px) {
  .ub-pc-card { width: 158px; }
  /* On touch devices the arrows just get in the way — swipe instead. */
  .ub-pc-arrow { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductCarousel.css"],"names":[],"mappings":"AAAA;yEACyE;;AAEzE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,2DAA2D;EAC3D,qBAAqB;EACrB,iCAAiC;EACjC,qBAAqB,WAAW,YAAY;AAC9C;AACA,kCAAkC,aAAa,EAAE,GAAG,WAAW;;AAE/D,4EAA4E;AAC5E;EACE,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,4CAA4C;EAC5C;gFAC8E;EAC9E,sBAAsB;EAEtB,2BAA2B;EAC3B;;oCAEkC;AACpC;AACA,mBAAmB,eAAe,EAAE;AACpC;EACE;+EAC6E;EAC7E,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB,WAAW,+CAA+C;EAC7E,6DAA6D;EAC7D,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd;;wBAEsB;EACtB,wBAAwB;EACxB,sBAAsB;EAEtB,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA,wCAAwC,oCAAoC,EAAE;;AAE9E;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB;EACpB,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA,gBAAgB,cAAc,EAAE;AAChC,oCAAoC,0BAA0B,EAAE;;AAEhE,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,qBAAqB,WAAW,+CAA+C;EAC/E,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,6CAA6C;EAC7C,4FAA4F;AAC9F;AACA,qBAAqB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC9E,sBAAsB,uCAAuC,EAAE;AAC/D,iBAAiB,UAAU,EAAE;AAC7B,iBAAiB,WAAW,EAAE;;AAE9B;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc,YAAY,EAAE;EAC5B,qEAAqE;EACrE,eAAe,aAAa,EAAE;AAChC","sourcesContent":["/* In-chat product gallery — horizontally scrollable cards the agent attaches\r\n   to a reply. Modern, brand-aligned (#5e1bff), soft depth, hover lift. */\r\n\r\n.ub-pc {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.ub-pc-track {\r\n  display: flex;\r\n  gap: 12px;\r\n  overflow-x: auto;\r\n  scroll-snap-type: x proximity;\r\n  /* vertical room so hover-lift + shadow are never clipped */\r\n  padding: 6px 2px 10px;\r\n  -webkit-overflow-scrolling: touch;\r\n  scrollbar-width: none;          /* Firefox */\r\n}\r\n.ub-pc-track::-webkit-scrollbar { display: none; }  /* WebKit */\r\n\r\n/* ── Card ─────────────────────────────────────────────────────────────── */\r\n.ub-pc-card {\r\n  flex: 0 0 auto;\r\n  width: 190px;\r\n  scroll-snap-align: start;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #ffffff;\r\n  border: 1px solid #ececf1;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  box-shadow: 0 1px 2px rgba(20, 20, 40, 0.04);\r\n  /* Pre-promote to its own GPU layer so the lift composites frame-1-smooth —\r\n     without this the browser promotes the layer mid-hover, which is the jank. */\r\n  will-change: transform;\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),\r\n              box-shadow 0.3s ease,\r\n              border-color 0.3s ease;\r\n}\r\n.ub-pc-card-link { cursor: pointer; }\r\n.ub-pc-card-link:hover {\r\n  /* Keep the subtle lift, but no glow shadow (was brand-purple, which clashes\r\n     with customers' custom widget colours) and a neutral darker-grey border. */\r\n  transform: translateY(-4px);\r\n  border-color: #cfcfd6;\r\n}\r\n\r\n/* ── Image ────────────────────────────────────────────────────────────── */\r\n.ub-pc-img {\r\n  position: relative;\r\n  width: 100%;\r\n  aspect-ratio: 4 / 3;          /* fixed -> no layout shift while images load */\r\n  background: linear-gradient(135deg, #f5f3ff 0%, #f0f0f5 100%);\r\n  overflow: hidden;\r\n}\r\n.ub-pc-img img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n  /* Sit on a GPU layer for the whole zoom: buttery scaling with no sub-pixel\r\n     edge shimmer. translateZ(0) is carried into the hover transform so it never\r\n     leaves the layer. */\r\n  transform: translateZ(0);\r\n  will-change: transform;\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n.ub-pc-card-link:hover .ub-pc-img img { transform: scale(1.06) translateZ(0); }\r\n\r\n.ub-pc-img-fallback {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #b9b4d6;\r\n  font-size: 30px;\r\n}\r\n\r\n.ub-pc-badge {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 8px;\r\n  padding: 3px 8px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  color: #2c2c3a;\r\n  background: rgba(255, 255, 255, 0.92);\r\n  backdrop-filter: blur(6px);\r\n  border-radius: 999px;\r\n  box-shadow: 0 1px 3px rgba(20, 20, 40, 0.12);\r\n  text-transform: capitalize;\r\n}\r\n\r\n/* ── Body ─────────────────────────────────────────────────────────────── */\r\n.ub-pc-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  padding: 11px 12px 12px;\r\n  flex: 1;\r\n}\r\n\r\n.ub-pc-brand {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: #8a86a0;\r\n}\r\n\r\n.ub-pc-title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  color: #1a1a2e;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.ub-pc-specs {\r\n  font-size: 11.5px;\r\n  line-height: 1.35;\r\n  color: #6f6b82;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.ub-pc-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  margin-top: auto;\r\n  padding-top: 9px;\r\n}\r\n\r\n.ub-pc-price {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #15151f;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ub-pc-cta {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 11.5px;\r\n  font-weight: 600;\r\n  color: #5e1bff;\r\n  white-space: nowrap;\r\n}\r\n.ub-pc-cta-ic { font-size: 9px; }\r\n.ub-pc-card-link:hover .ub-pc-cta { text-decoration: underline; }\r\n\r\n/* ── Scroll arrows ────────────────────────────────────────────────────── */\r\n.ub-pc-arrow {\r\n  position: absolute;\r\n  top: calc(50% - 12px);          /* roughly centred on the image, not the text */\r\n  transform: translateY(-50%);\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 999px;\r\n  border: 1px solid #ececf1;\r\n  background: #ffffff;\r\n  color: #3a3550;\r\n  font-size: 13px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  z-index: 3;\r\n  box-shadow: 0 4px 14px rgba(20, 20, 40, 0.16);\r\n  transition: opacity 0.2s ease, transform 0.15s ease, background 0.15s ease, color 0.15s ease;\r\n}\r\n.ub-pc-arrow:hover { background: #5e1bff; color: #fff; border-color: #5e1bff; }\r\n.ub-pc-arrow:active { transform: translateY(-50%) scale(0.92); }\r\n.ub-pc-arrow-l { left: -6px; }\r\n.ub-pc-arrow-r { right: -6px; }\r\n\r\n.ub-pc-arrow-off {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .ub-pc-card { width: 158px; }\r\n  /* On touch devices the arrows just get in the way — swipe instead. */\r\n  .ub-pc-arrow { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
